import { render } from "./ComponenteInputAlmacenamiento.vue?vue&type=template&id=9c94700c&scoped=true"
import script from "./ComponenteInputAlmacenamiento.vue?vue&type=script&lang=js"
export * from "./ComponenteInputAlmacenamiento.vue?vue&type=script&lang=js"

import "./ComponenteInputAlmacenamiento.vue?vue&type=style&index=0&id=9c94700c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c94700c"]])

export default __exports__